import { __read } from '../../node_modules/tslib/tslib.es6.esm.js';
import React__default, { createContext, useState } from 'react';

var NvTagsContext = createContext({});
var NvTagsContextProvider = function (_a) {
    var children = _a.children, onFinish = _a.onFinish, _b = _a.initialValues, initialValues = _b === void 0 ? [] : _b, openModal = _a.openModal, closeModal = _a.closeModal;
    var _c = __read(useState(initialValues), 2), checkedOptions = _c[0], setCheckedOptions = _c[1];
    var _d = __read(useState(initialValues), 2), tags = _d[0], setTags = _d[1];
    return (React__default.createElement(NvTagsContext.Provider, { value: {
            checkedOptions: checkedOptions,
            closeModal: closeModal,
            onFinish: onFinish,
            openModal: openModal,
            setCheckedOptions: setCheckedOptions,
            setTags: setTags,
            tags: tags,
        } }, children));
};

export { NvTagsContext, NvTagsContextProvider };
//# sourceMappingURL=NvTagsContextProvider.esm.js.map
